import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";
import type {TypedUseSelectorHook} from "react-redux";
import authReducer from "./reducers/authSlice";
import loggerReducer from "./reducers/loggerSlice";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";

const persistConfigAuth = {
  key: "auth",
  storage,
};

const authInfo = persistReducer(persistConfigAuth, authReducer);

const persistConfigLogs = {
  key: "logger",
  storage,
};

const loggerInfo = persistReducer(persistConfigLogs, loggerReducer);

const reducer = combineReducers({
  auth: authInfo,
  logs: loggerInfo,
});

export const store = configureStore({
  reducer,
  devTools: process.env.REACT_APP_DEV_TOOLS !== "true",
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
// export default store;
